import React from 'react';
import { Card } from './PublicShell';
import AvailabilityPerson from './AvailabilityPerson';
import DeployedPerson from './DeployedPerson';

export default function AvailabilitySection({title,subtitle,people,deployed=false}){
  if(!people?.length)return null;
  return <Card title={`${title} (${people.length})`} subtitle={subtitle}><div className="pub-list">
    {people.map((person,i)=>deployed?<DeployedPerson key={`${person.name}-${i}`} person={person}/>:<AvailabilityPerson key={`${person.name}-${i}`} person={person}/>) }
  </div></Card>;
}
